// Radio-value mapping for the Change Tenant dialog. Two constraints meet here:
//  - the empty-string model means "nothing selected" to form controls, so the '' = All
//    sentinel from ActiveTenantService cannot be a control value directly;
//  - a tenant whose NAME equals any internal sentinel must never collide with the All
//    option, so real tenants are namespaced with a prefix no tenant value can produce.
export const ALL_RADIO_VALUE = 'all';
const TENANT_PREFIX = 't:';

/** Tenant value ('' = All) → collision-proof radio value. */
export function toRadioValue(tenantValue: string): string {
  return tenantValue === '' ? ALL_RADIO_VALUE : `${TENANT_PREFIX}${tenantValue}`;
}

/** Radio value → tenant value ('' = All). */
export function fromRadioValue(radioValue: string): string {
  return radioValue === ALL_RADIO_VALUE ? '' : radioValue.slice(TENANT_PREFIX.length);
}
